import axios from 'axios';

export default {
    currentLocale() {
        return axios.get('/localization/currentLocale');
    },
    availableLocales() {
        return axios.get('/localization/availableLocales');
    },
    translations(locale = null) {
        const params = locale ? { locale } : {};
        return axios.get('/localization/translations', { params });
    },
    clearCache(locale = null) {
        const params = locale ? { locale } : {};
        return axios.post('/localization/clearCache/', {}, { params });
    },
};
